
import InfoIcon from '@/static/svg/prescription/info-icon.svg'
import TickIcon from '@/static/svg/prescription/tick-icon.svg'

export default {
  components: {
    InfoIcon,
    TickIcon,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    note: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
}
